import type { TranslationDict } from '../en';

const nl: TranslationDict = {
  'header.buy': 'Kopen',
  'header.sell': 'Verkopen',
  'spend.label': 'Je besteedt',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Je ontvangt',
  'payment.label': 'Betaalmethode',
  'payment.select': 'Selecteer',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Geen betaalmethoden voor dit paar',
  'wallet.label': 'Ontvangstportemonnee-adres',
  'wallet.placeholderBuy': 'Voer je ontvangstadres in',
  'wallet.placeholderSell': 'Voer je verzendadres in',
  'wallet.validating': 'Adres valideren...',
  'wallet.invalid': 'Voer een geldig portemonnee-adres in',
  'wallet.invalidServer': 'Ongeldig portemonnee-adres',
  'cta.buy': 'Koop {crypto}',
  'cta.sell': 'Verkoop {crypto}',
  'cta.gettingPrice': 'Beste prijs ophalen...',
  'cta.processing': 'Verwerken...',
  'footer.poweredBy': 'Aangedreven door ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Koersoverzicht',
  'rate.close': 'Sluiten',
  'rate.updatesIn': 'Koers wordt bijgewerkt over 00:{seconds}',
  'rate.noQuote': 'Geen offerte beschikbaar',
  'rate.exchangeRate': 'Wisselkoers',
  'rate.processingFee': 'Verwerkingskosten',
  'rate.networkFee': 'Netwerkkosten',
  'rate.provider': 'Aanbieder',
  'toast.orderCreated': 'Bestelling aangemaakt',
  'toast.redirecting': 'Doorsturen naar checkout...',
  'toast.orderFailed': 'Bestelling mislukt',
  'toast.couldNotCreate': 'Kon bestelling niet aanmaken',
  'toast.quoteError': 'Offerte-fout',
  'toast.noProviders': 'Geen aanbieders',
  'toast.somethingWrong': 'Er is iets misgegaan',
  'error.amountZero': 'Bedrag moet meer dan 0 zijn',
  'error.minAmountFiat': 'Minimumbedrag is {min} {currency}',
  'error.minAmountCrypto': 'Minimumbedrag is {min} {currency}',
  'error.noProviders': 'Geen aanbieders beschikbaar voor deze combinatie',
  'error.currencyUnavailableBuy': 'Deze valuta is niet beschikbaar voor kooporders',
  'error.currencyUnavailableSell': 'Deze valuta is niet beschikbaar voor verkooporders',
  'parity.info': 'Je wordt belast voor {receiveAmount} {crypto}, de rest tot {spendAmount} {fiat} wordt bijgeschreven op je {partner}-account',
  'redirect.secureBadge': 'Veilige betaling',
  'redirect.title': 'Betaling voortzetten',
  'redirect.description': 'Je wordt doorgestuurd naar {gateway} om je betaling te voltooien.',
  'redirect.countdown': 'Doorsturen over {seconds}...',
  'redirect.openTab': 'ACH openen in nieuw tabblad',
  'redirect.cancel': 'Annuleren',
  'checkout.noOrder': 'Geen bestelling gevonden',
  'checkout.goBack': 'Terug',
  'checkout.expired': 'Checkout verlopen',
  'checkout.expiredDesc': 'De sessie is verlopen. Probeer het opnieuw.',
  'checkout.startOver': 'Opnieuw beginnen',
  'checkout.cancel': 'Annuleren',
  'checkout.loading': 'Checkout laden...',
  'checkout.iframeTitle': 'Aanbieder-checkout',
  'checkout.widgetTitle': 'Betaling-checkout',
  'checkout.unknownMethod': 'Onbekende checkout-methode',
  'processing.default': 'Je bestelling verwerken...',
  'processing.pending': 'Wachten op betalingsbevestiging...',
  'processing.active': 'Je transactie verwerken...',
  'processing.generic': 'Verwerken...',
  'processing.checkingStatus': 'Status controleren...',
  'processing.orderId': 'Bestelnummer',
  'processing.provider': 'Aanbieder',
  'processing.amount': 'Bedrag',
  'processing.receiving': 'Ontvangen',
  'processing.network': 'Netwerk',
  'processing.toAddress': 'Naar adres',
  'processing.usuallyMinutes': 'Dit duurt meestal een paar minuten.',
  'processing.safeToClose': 'Je kunt deze pagina veilig sluiten - we sturen je een e-mail wanneer het voltooid is.',
  'complete.buyTitle': 'Aankoop voltooid!',
  'complete.sellTitle': 'Verkoop voltooid!',
  'complete.buyDesc': 'Je {crypto} is naar je portemonnee verzonden.',
  'complete.sellDesc': 'Je {fiat}-uitbetaling wordt verwerkt.',
  'complete.amountBuy': 'Ontvangen bedrag',
  'complete.amountSell': 'Verkocht bedrag',
  'complete.paidBuy': 'Betaald bedrag',
  'complete.paidSell': 'Uitbetalingsbedrag',
  'complete.network': 'Netwerk',
  'complete.wallet': 'Portemonnee',
  'complete.transaction': 'Transactie',
  'complete.provider': 'Aanbieder',
  'complete.orderId': 'Bestelnummer',
  'complete.completed': 'Voltooid',
  'complete.viewExplorer': 'Bekijk op Explorer',
  'complete.done': 'Klaar',
  'errorStep.failed': 'Betaling mislukt',
  'errorStep.cancelled': 'Bestelling geannuleerd',
  'errorStep.expired': 'Bestelling verlopen',
  'errorStep.refunded': 'Bestelling terugbetaald',
  'errorStep.unknown': 'Er is iets misgegaan',
  'errorStep.failedBuy': 'Je betaling kon niet worden verwerkt. Probeer het opnieuw of gebruik een andere betaalmethode.',
  'errorStep.failedSell': 'Je verkoop kon niet worden verwerkt. Probeer het opnieuw.',
  'errorStep.cancelledBuy': 'Je bestelling is geannuleerd. Er is geen betaling verwerkt.',
  'errorStep.cancelledSell': 'Je verkoop is geannuleerd. Er is geen crypto overgedragen.',
  'errorStep.expiredBuy': 'Je bestelling is verlopen. Start een nieuwe aankoop.',
  'errorStep.expiredSell': 'Je bestelling is verlopen. Start een nieuwe verkoop.',
  'errorStep.refundedBuy': 'Je betaling is terugbetaald. Het bedrag verschijnt binnen 5-10 werkdagen op je rekening.',
  'errorStep.refundedSell': 'Je crypto is geretourneerd. Het bedrag verschijnt binnenkort in je portemonnee.',
  'errorStep.genericDesc': 'Er is een onverwachte fout opgetreden. Probeer het opnieuw.',
  'errorStep.orderId': 'Bestelnummer',
  'errorStep.tryAgain': 'Opnieuw proberen',
  'errorStep.startOver': 'Opnieuw beginnen',
  'errorStep.return': 'Terug',
  'errorStep.needHelp': 'Hulp nodig? Neem contact op met ',
  'errorStep.reference': 'Referentie: {orderId}',
  'confirm.buyTitle': 'Aankoop bevestigen',
  'confirm.sellTitle': 'Verkoop bevestigen',
  'confirm.loading': 'Laden...',
  'confirm.provider': 'Aanbieder',
  'confirm.youPay': 'Je betaalt',
  'confirm.youSell': 'Je verkoopt',
  'confirm.youReceive': 'Je ontvangt',
  'confirm.wallet': 'Portemonnee',
  'confirm.network': 'Netwerk',
  'confirm.refundAddress': 'Restitutieadres',
  'confirm.parityNote': 'Het door de aanbieder in rekening gebrachte bedrag kan afwijken. De rest tot {amount} {crypto} wordt bijgeschreven op je {partner}-account.',
  'confirm.processing': 'Verwerken...',
  'confirm.confirmPay': 'Bevestigen en betalen',
  'confirm.confirmSell': 'Bevestigen en verkopen',
  'confirm.payout': '{currency}-uitbetaling',
  'modal.selectFiat': 'Selecteer fiatvaluta',
  'modal.selectCrypto': 'Selecteer cryptovaluta',
  'modal.choosePayment': 'Kies betaalmethode',
  'modal.selectCountry': 'Selecteer je land',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Populair',
  'modal.recommended': 'Aanbevolen',
  'modal.noCurrencies': 'Geen valuta gevonden',
  'modal.noPaymentMethods': 'Geen betaalmethoden gevonden',
  'modal.noCountries': 'Geen landen gevonden',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Locatie',
  'settings.darkMode': 'Donkere modus',
  'settings.privacy': 'Privacybeleid',
  'settings.terms': 'Gebruiksvoorwaarden',
  'settings.language': 'Taal',
  // ─── Additional ───
  'modal.chooseRamp': 'Ramp kiezen',
  'modal.bestPrice': 'Beste prijs',
  'modal.noQuotes': 'Geen offertes beschikbaar voor dit verzoek',
  'modal.noProvidersFound': 'Geen aanbieders gevonden',
  'payment.unavailableFor': 'Geen betaalmethoden beschikbaar voor {currency}',
  'skeleton.poweredBy': 'Aangedreven door NowRamp',
  'error.createOrderFailed': 'Aanmaken bestelling mislukt',
  'errorStep.returnToMerchant': 'Terug naar handelaar',
  'confirm.cryptoOnNetwork': '{crypto} op {network}',
  'payment.name.card': 'Kaart',
  'payment.name.bankTransfer': 'Bankoverschrijving',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default nl;
